module.exports = __webpack_public_path__ + "static/media/slidingBottomImg2.6a36aa66.png";